export const lenguagePortugues = {
  home: {
    title: "Olá, bem vindo(a)",
  }
}